/**
 * ViewTabs — underline tabs switching the two Insights views
 * (Studies tiles / Coordinators).
 */

import { NavLink } from 'react-router-dom';
import { LayoutGrid, Users } from 'lucide-react';

const tabCls = (active: boolean) =>
  `inline-flex min-h-[44px] items-center gap-1.5 border-b-2 px-2.5 text-sm font-medium transition-colors duration-150 sm:min-h-0 sm:py-2 ${
    active
      ? 'border-primary-600 text-primary-700 dark:text-primary-400'
      : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200'
  }`;

export function ViewTabs() {
  return (
    <nav className="flex gap-1 border-b border-gray-200 dark:border-gray-700" aria-label="Insights views">
      <NavLink to="/insights/studies" className={({ isActive }) => tabCls(isActive)}>
        <LayoutGrid size={16} aria-hidden="true" />
        Studies
      </NavLink>
      <NavLink to="/insights/coordinators" className={({ isActive }) => tabCls(isActive)}>
        <Users size={16} aria-hidden="true" />
        Coordinators
      </NavLink>
    </nav>
  );
}

export default ViewTabs;
